import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { MountedMaterialViewModel } from 'chronos-core-client';
import { combineLatest, Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { ConsumedMaterialState, ConsumedMaterialStore } from './consumed-material.store';
import { SortDirection, ConsumptionListFilters, ConsumptionListSorting } from 'chronos-shared';

@Injectable()
export class ConsumedMaterialQuery extends QueryEntity<ConsumedMaterialState, MountedMaterialViewModel> {
  public sorting$: Observable<ConsumptionListSorting> = this.select((state) => state.sorting);
  public filters$: Observable<ConsumptionListFilters> = this.select((state) => state.filters);
  public palletSequence$: Observable<SortDirection> = this.select((state) => state.sorting.palletSequence);

  public consumedMaterial$: Observable<MountedMaterialViewModel[]> = combineLatest([this.filters$, this.sorting$]).pipe(
    switchMap(() =>
      this.selectAll({
        filterBy: this.filterByContainerType,
        sortBy: this.sortBySequenceNumber
      })
    )
  );

  constructor(protected store: ConsumedMaterialStore) {
    super(store);
  }

  private filterByContainerType = (consumedMaterial: MountedMaterialViewModel): boolean =>
    this.getValue().filters.showOnlyDummy ? consumedMaterial.container.isVirtualContainer : true;

  private sortBySequenceNumber = (firstContainer: MountedMaterialViewModel, secondContainer: MountedMaterialViewModel): number => {
    const comparison = firstContainer.materialSequence - secondContainer.materialSequence;

    return this.getValue().sorting.palletSequence === SortDirection.ASC ? comparison : -comparison;
  };
}
